import * as Apollo from '@apollo/client';

import { useIsClient } from '@utils/common';

import {
  UserSubscriptionInfoQuery,
  UserSubscriptionInfoQueryVariables,
  useUserSubscriptionInfoQuery,
} from './gql/graphql.v3.generated';

export const useUserSubscriptionInfo = (
  options?: Apollo.QueryHookOptions<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>,
) => {
  const isClient = useIsClient();

  const { data, loading } = useUserSubscriptionInfoQuery({
    ...options,
    context: {
      ...options?.context,
      ignoreAuthError: true,
    },
    skip: !isClient
  });

  return {
    viewer: data?.viewer || null,
    smartInfo: data?.smartInfo || null,
    loading,
  };
};
